/*
 * @Description: 
 * @Author: liushuai
 * @LastEditTime: 2020-08-25 15:18:06
 */
export var getPopeditValue = function getPopeditValue(dataSources, code) {
  var target = dataSources.find(function (ds) {
    return ds.code === code;
  });
  return {
    name: target.symbol
  };
};
//# sourceMappingURL=util.js.map
